import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SavedSearchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"saved_search"}/>
}
